import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RiskCommentDialogData { title: string; subtitle?: string; label: string; confirm: string; required: boolean; destructive?: boolean }

/** One dialog for approve (optional comment), reject / close / reopen (required). */
@Component({
  selector: 'app-risk-comment-dialog',
  templateUrl: './risk-comment-dialog.component.html',
  styleUrls: ['./risk-comment-dialog.component.scss'],
  standalone: false,
})
export class RiskCommentDialogComponent {
  form: FormGroup;
  readonly dialogRef = inject<MatDialogRef<RiskCommentDialogComponent>>(MatDialogRef);
  readonly data = inject<RiskCommentDialogData>(MAT_DIALOG_DATA);

  constructor() {
    this.form = new FormGroup({ comment: new FormControl('', this.data.required ? [Validators.required, Validators.maxLength(4000)] : [Validators.maxLength(4000)]) });
  }
  confirm(): void {
    const comment = (this.form.value.comment || '').trim();
    if (this.form.invalid || (this.data.required && !comment)) return;
    this.dialogRef.close({ comment });
  }
  cancel(): void { this.dialogRef.close(undefined); }
}
